import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../components/Toast';
import { LOGO_TOPBAR } from '../logos';

// ⚠️ Ajustes SOLO usa useAuth() — nunca useData() (ver errores conocidos)
export default function Ajustes() {
  const { clinicName, setClinicName, clinicLogo, setClinicLogo, changePassword, user } = useAuth();
  const toast = useToast();

  const [nombre, setNombre] = useState(clinicName);
  const [passActual, setPassActual] = useState('');
  const [passNueva, setPassNueva] = useState('');
  const [passConfirm, setPassConfirm] = useState('');

  // El logo se guarda en localStorage, que tiene ~5 MB de cupo para TODO
  // (incluidos clientes y citas). Una foto de camara sin reducir lo llena y
  // rompe la app, asi que se reescala a 256px antes de guardarla.
  const subirLogo = (e) => {
    const file = e.target.files && e.target.files[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) { toast.show('Solo se aceptan imágenes', 'error'); return; }
    const reader = new FileReader();
    reader.onload = (ev) => {
      const img = new Image();
      img.onload = () => {
        const max = 256;
        const escala = Math.min(max / img.width, max / img.height, 1);
        const canvas = document.createElement('canvas');
        canvas.width = Math.round(img.width * escala);
        canvas.height = Math.round(img.height * escala);
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        // PNG para conservar transparencia si el logo la tiene
        try {
          setClinicLogo(canvas.toDataURL('image/png'));
          toast.show('Logo actualizado');
        } catch (err) {
          toast.show('No se pudo guardar el logo', 'error');
        }
      };
      img.onerror = () => toast.show('Imagen no válida', 'error');
      img.src = ev.target.result;
    };
    reader.onerror = () => toast.show('No se pudo leer el archivo', 'error');
    reader.readAsDataURL(file);
  };

  const cambiarPass = () => {
    if (!passNueva || passNueva.length < 6) { toast.show('La nueva contraseña debe tener al menos 6 caracteres', 'error'); return; }
    if (passNueva !== passConfirm) { toast.show('Las contraseñas no coinciden', 'error'); return; }
    const r = changePassword(passActual, passNueva);
    if (!r.ok) { toast.show(r.error, 'error'); return; }
    setPassActual(''); setPassNueva(''); setPassConfirm('');
    toast.show('Contraseña actualizada');
  };

  const L = ({ children }) => <label style={{ fontSize: 13, fontWeight: 600, color: '#475569', display: 'block', margin: '10px 0 5px' }}>{children}</label>;

  return (
    <div>
      <h1 style={{ fontSize: 20, fontWeight: 800, marginBottom: 16 }}>Ajustes</h1>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))', gap: 14, maxWidth: 860 }}>
        <div className="card" style={{ padding: 18 }}>
          <div style={{ fontWeight: 700, marginBottom: 8 }}>Empresa</div>
          <L>Nombre de la empresa</L>
          <input type="text" value={nombre} onChange={e => setNombre(e.target.value)} />
          <button className="btn-primary" style={{ marginTop: 12 }}
            onClick={() => { setClinicName(nombre.trim() || 'ACERO & CRISTAL MTY'); toast.show('Nombre actualizado'); }}>
            Guardar nombre
          </button>

          <L>Logo (esquina superior izquierda)</L>
          <div style={{ marginBottom: 10, display: 'flex', alignItems: 'center', gap: 12 }}>
            <img
              src={clinicLogo || LOGO_TOPBAR}
              alt="logo"
              style={{ height: 40, width: 40, objectFit: 'cover', borderRadius: 8, background: '#185fa5' }}
            />
            <div style={{ fontSize: 12, color: '#94a3b8' }}>
              {clinicLogo ? 'Logo personalizado' : 'Logo por defecto'}
            </div>
            {clinicLogo && (
              <button className="btn-danger" style={{ padding: '5px 10px', fontSize: 13, marginLeft: 'auto' }}
                onClick={() => { setClinicLogo(''); toast.show('Se restauró el logo por defecto'); }}>Quitar</button>
            )}
          </div>
          <input type="file" accept="image/*" onChange={subirLogo} style={{ padding: 8 }} />
        </div>

        <div className="card" style={{ padding: 18 }}>
          <div style={{ fontWeight: 700, marginBottom: 8 }}>Cambiar contraseña</div>
          <div style={{ fontSize: 13, color: '#94a3b8', marginBottom: 4 }}>Usuario: <b>{user.usuario}</b></div>
          <L>Contraseña actual</L>
          <input type="password" value={passActual} onChange={e => setPassActual(e.target.value)} />
          <L>Nueva contraseña</L>
          <input type="password" value={passNueva} onChange={e => setPassNueva(e.target.value)} />
          <L>Confirmar nueva contraseña</L>
          <input type="password" value={passConfirm} onChange={e => setPassConfirm(e.target.value)} />
          <button className="btn-primary" style={{ marginTop: 14 }} onClick={cambiarPass}>Actualizar contraseña</button>
        </div>
      </div>
    </div>
  );
}
